import { MARQUEE } from "@/data/content";

export default function Marquee() {
    const items = [...MARQUEE, ...MARQUEE];
    return (
        <div className="marquee-track bg-ink border-y border-white/10 py-6 overflow-hidden" data-testid="marquee-section">
            <div className="marquee">
                {items.map((t, i) => (
                    <span key={i} className="flex items-center whitespace-nowrap">
                        <span className="text-2xl md:text-4xl font-display font-light text-white/85 px-8">{t}</span>
                        <span className="w-2 h-2 rounded-full bg-brand-red" />
                    </span>
                ))}
            </div>
        </div>
    );
}
